import { render, staticRenderFns } from "./reports-icon.vue?vue&type=template&id=9c4ef6ea"
import script from "./reports-icon.vue?vue&type=script&lang=js"
export * from "./reports-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports